import * as React from "react";
import { Redirect } from "react-router-dom";
import Modal from "react-awesome-modal";
import Vimeo from "@u-wave/react-vimeo";

import withServices from "../../../../HOCs/withServices";
import NavBar from "../../../../components/CustomNav/CustomNav.Component";

import {
  Container,
  FormWrapper,
  InputWrapper,
  CtaWrapper,
  ModalContainer,
  FeedbackP,
} from "../../Common/Common.styles";

import {
  Section,
  Row,
  Col,
  Heading,
  FeatureItem,
  StatItem,
  Testimonial,
  Footer,
  Button,
  FeatureGrid,
  Stat,
  TooltipParagraph,
  ItemHeading,
} from "./ParentRegistration.styles";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "../../../../components/DatePicker/DatePickerComponent";

import course1 from "../../../../assets/images/parentreg/course1.png";
import course2 from "../../../../assets/images/parentreg/course2.png";
import course3 from "../../../../assets/images/parentreg/course3.png";
import course4 from "../../../../assets/images/parentreg/course4.png";
import course5 from "../../../../assets/images/parentreg/course5.png";
import course6 from "../../../../assets/images/parentreg/course6.png";
import course7 from "../../../../assets/images/parentreg/course7.png";
import course8 from "../../../../assets/images/parentreg/course8.png";
import course9 from "../../../../assets/images/parentreg/course9.png";
import course10 from "../../../../assets/images/parentreg/course10.png";
import course11 from "../../../../assets/images/parentreg/course11.png";
import course12 from "../../../../assets/images/parentreg/course12.png";
import tick from "../../../../assets/images/parentreg/tick.png";
import assess from "../../../../assets/images/parentreg/assess.jpg";
import research from "../../../../assets/images/parentreg/research.png";
import students from "../../../../assets/images/parentreg/students.png";
import countries from "../../../../assets/images/parentreg/countries.png";
import stars from "../../../../assets/images/parentreg/stars.png";

interface IProps {
  services?: any;
  history?: any;
}
const vimeoVar1 = "why_plex_1";

class ParentRegistration extends React.Component<IProps> {
  public state = {
    username: "",
    password: "",
    confirmpassword: "",
    email: "",
    phone: "",
    age: "",
    onboardingQuestions: [],
    signUpSuccess: false,
    feedbackOpen: false, // toggles modal
    feedbackLoaded: false,
    dateObj: null,
    registerOpen: false,
    vimeoID: null,
    showF1Track: false,
  };
  private ls = window.localStorage;

  constructor(props) {
    super(props);
    this.navigate = this.navigate.bind(this);
    this.registerParent = this.registerParent.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  public async componentDidMount() {
    const {
      history,
      services: {
        isUserLoggedIn,
        parentsAPI,
        adminAPI,
        currentBaseUrl,
        currentDesignation,
        isUserUpgraded,
      },
    } = this.props;

    if (isUserLoggedIn) {
      if (isUserUpgraded) {
        this.navigate("parents/home");
      }
    }

    const onboardingQuestions = this.ls.getItem("onboardingQuestions");
    if (onboardingQuestions === null) {
      console.log("No onboarding questions answered");
    } else {
      const questions = JSON.parse(onboardingQuestions);
      this.setState({ onboardingQuestions: questions });
    }

    // fetch vimeo vid
    // request requires auth - ask for an endpoint mod
    // const vimeoRes = await adminAPI.fetchVimeoSystemVar(vimeoVar1);
    // if(vimeoRes.ok) {
    //   console.log(JSON.stringify(vimeoRes, null, 2))
    //   this.setState({vimeoLoaded: true, vimeoID: vimeoRes.data.value});
    // }
  }

  public handleChange(event) {
    const currentField = event.target.dataset.arg;
    this.state[currentField] = event.target.value;
    console.info(this.state[currentField]);
  }
  public ageChangeHandler = (dateObj) => {
    const age = `${dateObj.year}-${dateObj.month}-${dateObj.day}`;
    this.setState({ dateObj, age });
  };

  public navigate(destination) {
    const { history } = this.props;
    history.push(destination);
  }

  public showF1TrackHandler = () => {
    this.setState({ showF1Track: true });
  };
  public async registerParent(event) {
    const {
      username,
      email,
      phone,
      age,
      password,
      confirmpassword,
      onboardingQuestions,
    } = this.state;
    const {
      services: { fixturesAPI, baseAPI },
    } = this.props;
    // handle form submission
    event.preventDefault();
    const payload = {
      // username,
      childdob: age,
      email,
      onboardingQuestions,
      password,
      phone,
    };
    console.info("Payload: " + JSON.stringify(payload, null, 5));
    // post data and navigate on success
    const registerRes = await baseAPI.post(
      `/users/registration/parents`,
      JSON.stringify(payload),
      true
    );
    if (registerRes.ok) {
      toast.success("Account Created Successfully");
      setTimeout(() => {
        this.props.history.replace("/login");
      }, 2000);
    } else {
      toast.error("Account Creation Failed! Check your Details!");
    }
  }

  public closeModal = (status) => {
    if (status === true) {
      // sign up was successful, go to login
      this.props.history.push("/login");
    }
    this.setState({ feedbackOpen: false });
  };
  public toggleRegisterModal = () => {
    const { registerOpen } = this.state;
    this.setState({ registerOpen: !registerOpen });
  };
  public renderFeedbackModal = () => {
    const { feedbackOpen, signUpSuccess, feedbackLoaded } = this.state;
    if (feedbackLoaded) {
      let content = (
        <FeedbackP success={signUpSuccess}>
          <span>Signed Up Successfully! </span>
          <br /> Check your email for confirmation!
        </FeedbackP>
      );
      if (!signUpSuccess) {
        content = (
          <FeedbackP success={signUpSuccess}>
            <span>Sign Up Failed! </span>
            <br /> check your details and try again!
          </FeedbackP>
        );
      }
      return (
        <Modal
          visible={feedbackOpen}
          effect="fadeInUp"
          onClickAway={this.closeModal.bind(this, signUpSuccess)}
        >
          <ModalContainer>{content}</ModalContainer>
        </Modal>
      );
    } else {
      console.log("no feedback yet");
      return;
    }
  };
  public renderRegisterModal = () => {
    const { registerOpen } = this.state;
    return (
      <Modal
        visible={registerOpen}
        effect="fadeInUp"
        onClickAway={this.toggleRegisterModal}
        width="600"
      >
        <FormWrapper width="100%">
          <i
            className="fa fa-times-circle-o close-modal"
            aria-hidden="true"
            onClick={this.toggleRegisterModal}
          />
          <form onSubmit={this.registerParent}>
            <h2 className="form-header">REGISTER YOUR DETAILS</h2>
            <div className="fields-wrapper">
              <InputWrapper>
                <p>EMAIL ADDRESS</p>
                <input
                  type="email"
                  id="email"
                  className="custom-textfield"
                  placeholder="Enter your email address"
                  required={true}
                  data-arg="email"
                  onChange={this.handleChange}
                />
              </InputWrapper>
              <InputWrapper>
                <p>PHONE NUMBER</p>
                <input
                  type="text"
                  id="phone"
                  className="custom-textfield"
                  placeholder="Enter your phone number"
                  required={true}
                  data-arg="phone"
                  onChange={this.handleChange}
                />
              </InputWrapper>

              <InputWrapper>
                <p>PASSWORD</p>
                <input
                  type="password"
                  id="password"
                  className="custom-textfield"
                  placeholder="Enter a password for your account"
                  required={true}
                  data-arg="password"
                  onChange={this.handleChange}
                />
              </InputWrapper>
              <InputWrapper>
                <TooltipParagraph>
                  CHILD DOB <a href="#">Why do we need this?</a>
                  <span className="hover-tooltip">
                    Performance Learning’s assessments are tailored to your
                    child’s age hence why we ask this question
                  </span>
                </TooltipParagraph>
                <DatePicker
                  value={this.state.dateObj}
                  onChange={this.ageChangeHandler}
                />
              </InputWrapper>
            </div>

            <CtaWrapper>
              <button
                style={{ color: "#000" }}
                className="green-button register-parent"
                type="submit"
              >
                Confirm Details
              </button>
            </CtaWrapper>

            {/* <Disclaimer>
                By signing up you agree to our{" "}
                <a
                  href="https://myperformancelearning.com/terms-of-service/"
                  target="_blank"
                >
                  Terms and Conditions
                </a>
                ,{" "}
                <a
                  href="https://myperformancelearning.com/privacy-policy/"
                  target="_blank"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="http://myperformancelearning.com/cookie-policy/"
                  target="_blank"
                >
                  Cookie Policy
                </a>
              </Disclaimer> */}
          </form>
        </FormWrapper>
      </Modal>
    );
  };
  public render() {
    return (
      <Container>
        <NavBar />
        <ToastContainer />
        {this.renderRegisterModal()}

        {this.renderFeedbackModal()}
        <Section marginTop="3em">
          <Heading color="#acff24" fontSize="28px">
            LIMITED TIME BACK TO SCHOOL OFFER
          </Heading>
          <Heading color="#3ee9f7" fontSize="36px">
            The road to resilience
          </Heading>
          <Heading fontSize="36px">
            Recover lost learning time and safe-guard Your child's mental health
            and well-being
          </Heading>
          <Button onClick={this.toggleRegisterModal}>
            Start your online assessment now
          </Button>
          <p>
            The assessment provides the biggest impact on child learning
            performance and future success of children currently between Year 5
            and Year 13 (ages 9 and above).
          </p>
        </Section>

        <Section marginTop="2em" backgroundColor="#000">
          <Row width="70%">
            <Col>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>15-minute online assessment</p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>A detailed pdf report</p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Recommendation plan on their strengths and areas to improve on
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Detailed insight on how their current skill level is affecting
                  their classroom and exam-hall performance
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Insightful analysis about their perceptions, their behaviour
                  and their resilience towards learning
                </p>
              </FeatureItem>
            </Col>
            <Col>
              <img src={assess} alt="" className="poster" />
            </Col>
          </Row>
        </Section>

        <Section marginTop="2em" padding="2em" backgroundColor="#1a1a1a">
          <Heading fontSize="32px">How does it work?</Heading>
          <Row width="70%">
            <Col alignItems="center" width="auto">
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Your child takes our online assessment three times a year.
                  After the first assessment, you will receive a detailed
                  analysis and recommendations of areas for improvement.
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Using the results of your child’s assessment, you can work
                  with your child to improve on the areas identified in the
                  assessment.
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Your child then retakes the assessment to ensure they have
                  improved on the various behavioural and psychology areas
                  needed to succeed at school.
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  You can then again work with your child to improve their
                  performance based on the second recommendations.
                </p>
              </FeatureItem>
              <FeatureItem>
                <img className="tick" src={tick} alt="" />
                <p>
                  Your child takes the final assessment for the year to monitor
                  improvement and provide final recommendations.
                </p>
              </FeatureItem>
            </Col>
          </Row>
          <p>
            We highly recommend that your child completes all three assessments
            for the year to ensure we monitor improvement over time.
          </p>
        </Section>

        <Section marginTop="4em">
          <Heading fontSize="18px">
            This 15-min assessment measures the following in your child's
            performance
          </Heading>
        </Section>

        <Section backgroundColor="#1a1a1a">
          <Row wrap={true} width="70%">
            <Col width="30%" alignItems="center">
              <ItemHeading fontSize="18px">
                Mental health &amp; Wellbeing
              </ItemHeading>
            </Col>

            <ItemHeading width="30%" fontSize="18px">
              Attitudes &amp; behaviours towards learning
            </ItemHeading>
            <Col width="30%" alignItems="center">
              <ItemHeading fontSize="18px">
                Progress &amp; attainment
              </ItemHeading>
            </Col>
          </Row>
        </Section>

        <Section marginTop="2em">
          <Heading fontSize="32px">
            Recommended by <span> Harrow School</span>
          </Heading>
          <Heading fontSize="18px">
            “AN ACCURATE AND INSIGHTFUL ASSESSMENT TOOL FROM WHICH THE OUTCOMES
            MATCHED THE PERCEPTIONS OF THE BOYS AND THEIR HOUSE MASTERS AND
            TUTORS, AND WHICH PRESENTED INFORMATION ABOUT OUR PUPILS’ LEARNING
            HABITS AND PERCEPTIONS WITH CLARITY. THE GAMIFIED AND DYNAMIC
            ELEMENTS OF THIS WERE IMPRESSIVE AND IT WAS CLEAR THAT THE BOYS
            ENJOYED THE PROCESS.
          </Heading>
          <p>Mr. Alastair Chirnside, Deputy Headmaster - Harrow School</p>
          <div
            style={{
              width: "200px",
              height: "8px",
              backgroundColor: "#acff24",
              marginTop: "1.5em",
            }}
          />
        </Section>

        <Section>
          <Heading fontSize="32px">What does the assessment focus on?</Heading>

          <FeatureGrid>
            <StatItem>
              <img src={course1} alt="" className="icon" />
              <ItemHeading color="#acff24" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                To Establish their strength &amp; areas to improve on
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course9} alt="" className="icon" />
              <ItemHeading color="#ff0086" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Organize, structure &amp; retain information
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course5} alt="" className="icon" />
              <ItemHeading color="#3ee9f7" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Recall, Apply & Analyse Information
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course11} alt="" className="icon" />
              <ItemHeading color="#ffd515" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Creative & heavy text subjects
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course7} alt="" className="icon" />
              <ItemHeading color="#a600ff" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Linear & Analytical Subjects
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course4} alt="" className="icon" />
              <ItemHeading color="#e14404" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Diffuse nerves and anxiety towards tests
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course1} alt="" className="icon" />
              <ItemHeading color="#acff24" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Access positive emotions while learning
              </ItemHeading>
            </StatItem>

            <StatItem>
              <img src={course9} alt="" className="icon" />
              <ItemHeading color="#ff0086" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Diffuse negative emotions while learning
              </ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course5} alt="" className="icon" />
              <ItemHeading color="#3ee9f7" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">Test & Exam preparation</ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course11} alt="" className="icon" />
              <ItemHeading color="#ffd515" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">Sleep & Recovery</ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course8} alt="" className="icon" />
              <ItemHeading color="#a600ff" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">Set goals & outcomes</ItemHeading>
            </StatItem>
            <StatItem>
              <img src={course4} alt="" className="icon" />
              <ItemHeading color="#e14404" fontSize="18px">
                Your childs approach to:{" "}
              </ItemHeading>
              <ItemHeading fontSize="20px">
                Create & stick to revision timetables
              </ItemHeading>
            </StatItem>
          </FeatureGrid>
        </Section>
        <Section>
          <Button onClick={this.toggleRegisterModal}>
            Start your online assessment now
          </Button>
        </Section>

        <Section marginTop="2em">
          <Heading fontSize="24px">
            Over 10,000 pupils, 3,000 Teachers, <br /> 140 schools have trusted
            us
          </Heading>
          <FeatureGrid>
            <Stat height="240px">
              <img className="stat-icon" src={research} alt="" />
              <Heading color="#acff24" fontSize="18px">
                1.2 Million
              </Heading>
              <p>
                Spent on research <br /> & development
              </p>
            </Stat>
            <Stat height="240px">
              <img className="stat-icon" src={students} alt="" />
              <Heading color="#acff24" fontSize="18px">
                10,364
              </Heading>
              <p>
                Students across <br /> the world
              </p>
            </Stat>
            <Stat height="240px">
              <img className="stat-icon" src={countries} alt="" />
              <Heading color="#acff24" fontSize="18px">
                3 Countries
              </Heading>
              <p>
                UK, UAK, <br />
                Africa
              </p>
            </Stat>
            <div>
              <Heading fontSize="20px">
                Trusted by <span>Parents</span>
              </Heading>
              <Stat>
                <Vimeo
                  video="https://player.vimeo.com/video/408949971"
                  autoplay={false}
                  responsive={true}
                  width="320px"
                />
              </Stat>
            </div>

            <div>
              <Heading fontSize="20px">
                Trusted by <span>Teachers</span>
              </Heading>
              <Stat>
                <Vimeo
                  video="https://player.vimeo.com/video/408926755"
                  autoplay={false}
                  responsive={true}
                  width="320px"
                />
              </Stat>
            </div>
            <div>
              <Heading fontSize="20px">
                Trusted by <span>Learners</span>
              </Heading>
              <Stat>
                <Vimeo
                  video="https://player.vimeo.com/video/408955192"
                  autoplay={false}
                  responsive={true}
                  width="320px"
                />
              </Stat>
            </div>
          </FeatureGrid>
        </Section>

        <Section marginTop="3em">
          <Heading fontSize="20px">Happy Parents</Heading>
          <FeatureGrid>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>
                "I have seen a drastic improvement in my child's
                self-confidence, memory and time management skills."
              </p>
              <Heading fontSize="15px">SUMANA, MUM OF TWO</Heading>
            </Testimonial>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>
                "Sessions are very informative, a motivating change agent for
                the better for our family.""
              </p>
              <Heading fontSize="15px">HEATHER MUM OF TWO</Heading>
            </Testimonial>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>“I was amazed at what this was able to deliver."</p>
              <Heading fontSize="15px">ALI, MUM OF THREE</Heading>
            </Testimonial>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>
                "This gives the child the tools to manage what it is they need
                to do, it allows them to teach themselves.
              </p>
              <Heading fontSize="15px">CANDICE, MUM OF TWO</Heading>
            </Testimonial>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>"I don't think there's anything that is equal to this"</p>
              <Heading fontSize="15px">IESTYN DAD OF TWO</Heading>
            </Testimonial>
            <Testimonial>
              <img src={stars} alt="" className="rating" />
              <p>"It was really helpful in showing me how to assist my son</p>
              <Heading fontSize="15px">PAUL, DAD OF TWO</Heading>
            </Testimonial>
          </FeatureGrid>
        </Section>
        <Section>
          <Button onClick={this.toggleRegisterModal}>
            Start your online assessment now
          </Button>
        </Section>

        {/* <Section backgroundColor="#1a1a1a" marginTop="2em">
          <Footer>
            <Heading fontSize="18px">GET PLEX</Heading>
            <Heading fontSize="24px">REGISTER &amp; CHOOSE YOUR PLAN</Heading>
            <Button  onClick={this.toggleRegisterModal}>
              Let's Go
            </Button>
          </Footer>
        </Section> */}
      </Container>
    );
  }
}

export default withServices(ParentRegistration);



// WEBPACK FOOTER //
// ./src/pages/Onboard/Parent/Registration/ParentRegistration.tsx